// USED IN FLEXIBLE COLUMN CONTAINER BLOCK, EXTENDED SEARCH BLOCK

import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";

export default function SwiperCarousel() {
  const swiperElement = document.querySelectorAll<HTMLDivElement>(".js-swiper-carousel");

  if (swiperElement && swiperElement.length > 0) {
    Swiper.use([Navigation, Autoplay]);

    // WCAG 2.2.2 - never auto-advance for users who ask for reduced motion.
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    swiperElement.forEach((el: HTMLDivElement) => {
      if (el) {
        const carouselEl = el.querySelector<HTMLDivElement>(".swiper");
        const nextBtn = el.querySelector<HTMLButtonElement>(".swiper-btn-next");
        const prevBtn = el.querySelector<HTMLButtonElement>(".swiper-btn-prev");

        if (carouselEl) {
          const desktopSlides = carouselEl.getAttribute("data-desktop-slides");
          const tabletSlides = carouselEl.getAttribute("data-tablet-slides");
          const mobileSlides = carouselEl.getAttribute("data-mobile-slides");
          const enableAutoPlay = carouselEl.getAttribute("data-enable-autoplay");

          new Swiper(carouselEl, {
            loop: true,
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
            },
            autoplay: enableAutoPlay === "True" && !prefersReducedMotion ? {
              delay: 6000,
              pauseOnMouseEnter: true,
              // without this, pauseOnMouseEnter stops autoplay permanently instead of resuming on leave
              disableOnInteraction: false
            } : false,
            breakpoints: {
              576: {
                slidesPerView: mobileSlides ? parseInt(mobileSlides) : 1,
              },
              768: {
                slidesPerView: tabletSlides ? parseInt(tabletSlides) : 2,
              },
              993: {
                slidesPerView: desktopSlides ? parseInt(desktopSlides) : 3,
              },
            },
          });
        }
      }
    });
  }
}
